import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconMailbox: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="mailbox, inbox"><path d="M12.25 22V9.25C12.25 6.76472 10.2353 4.75 7.74998 4.75H7.5" stroke="currentColor" strokeWidth="1.5"/><path d="M16.75 4.75H7.25C4.76472 4.75 2.75 6.76472 2.75 9.25V19.25H21.25V9.25C21.25 6.76472 19.2353 4.75 16.75 4.75Z" stroke="currentColor" strokeWidth="1.5"/><path d="M5.25 9.75H9.75" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconMailbox;
